<template>
  <CAlert
    class="flex w-full justify-stretch @container"
    variant="error"
    :title="t('replacement.discontinuing')"
    data-test="replacement-alert"
  >
    <template #text>
      <div class="flex flex-col justify-between w-full gap-y-4 @[50rem]:flex-row">
        <div>
          <CText v-if="showDescription" data-test="replacement-alert-description">
            {{ t('replacement.remove_or_replace') }}
          </CText>
          <template v-if="replacement">
            <CText>
              <template v-if="showVariantName">
                {{ t('replacement_article') }}:
                <CLink :to="`/produkt/${replacement.variantSlug}`" data-test="replacement-alert-link-with-name">
                  {{ replacement.name }}
                </CLink>
              </template>
              <CLink v-else :to="`/produkt/${replacement.variantSlug}`" data-test="replacement-alert-link-without-name">
                {{ t('replacement_article') }}
              </CLink>
            </CText>
          </template>
        </div>
        <CButton
          v-if="showBuyButton && replacement && isLoggedIn"
          :class="'w-full @[50rem]:w-auto'"
          variant="secondary"
          data-test="replacement-alert-add-to-cart"
          @click="emit('add', replacement)"
        >
          {{ t('add_replacement_article') }}
        </CButton>
      </div>
    </template>
  </CAlert>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores';

const emit = defineEmits<{
  (e: 'add', value: any): void;
}>();

type Props = {
  replacement?: any;
  showBuyButton?: boolean;
  showVariantName?: boolean;
  showDescription?: boolean;
};

withDefaults(defineProps<Props>(), {
  replacement: undefined,
  showBuyButton: true,
  showVariantName: true,
  showDescription: true,
});

const { isLoggedIn } = storeToRefs(useUserStore());
const { t } = useI18n();
</script>

<script lang="ts">
export default defineComponent({
  name: 'ReplacementAlert',
});
</script>
